import React, { useContext, useEffect } from 'react'
import { useHeapEvents } from '@toasttab/shared/src/hooks/useHeapEvents'
import { I18nextContext } from '../context/i18nextContext'

const PageElement = ({ children }: any) => {
  useHeapEvents('isCustomer', 'isCustomer')
  const { language } = useContext(I18nextContext)

  useEffect(() => {
    document.documentElement.lang = language
  }, [language])

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}

export default PageElement
